import React from 'react';

const StatusBadgeRow = ({ estado }) =>
{
   const estadoClass = "StatusBadgeRow label label-" + (estado.toLowerCase() === "rechazada" ? "danger" : "primary");
   return (<h4><span className={estadoClass}>{estado.toUpperCase()}</span></h4>);
}

export default StatusBadgeRow;
